class EnterDataFormInputController {

    $onInit() {
        if (this.inputType === 'datetime-local' && this.ngModel !== null) {
            this.ngModel = new Date(this.ngModel);
        }

        if (this.inputType === 'enum' && this.ngModel !== null) {
            const saved_enum = this.field.enum_data.filter((obj) => obj.id === this.ngModel);
            if (saved_enum.length > 0) {
                this.selectedEnum = saved_enum[0];
            }
        }
    }

    /***
     * Callback function for when an item in an enum drop down is selected.
     */
    setEnumValue(item) {
        this.ngModel = item.id;
        this.selectedEnum = item;
    }

}

export default EnterDataFormInputController;


// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-form-input/enter-data-form-input-controller.js